export default __webpack_public_path__ + "static/media/clock.d1c75d68.svg";